import { Tab } from '@headlessui/react';
import { TableTab } from '../DemoDashboard/EnvironmentDashboard/EnvironmentSessionBreakdown/TableTab';

type TableTabsProps = {
  onChange: (index: number) => void;
  defaultIndex?: number;
};

export const TableTabs = ({ onChange, defaultIndex }: TableTabsProps) => {
  return (
    <Tab.Group
      onChange={onChange}
      defaultIndex={defaultIndex}
    >
      <Tab.List className="border border-ds-natural-150 rounded-lg">
        <TableTab isLeft>Demos given</TableTab>
        <TableTab>Sandbox visits</TableTab>
      </Tab.List>
    </Tab.Group>
  );
};
